import { redirect } from "react-router-dom";

import getPath from "@/modules/get-path";
import { createProjectMutation } from "@/services/lukita/mutations";
import { getAccount } from "../helpers";

export default async function createProjectAction({ request }) {
  const formData = await request.formData();
  const name = formData.get("name");
  const errors = {};

  if (name.trim().length == 0) {
    errors.name = "Name is required";
  }

  if (Object.keys(errors).length) {
    return { errors };
  }

  const account = await getAccount();
  const { createProject } = await createProjectMutation(name, account?.id);
  return redirect(getPath(createProject.project));
}
